<template>
  <div class="container row">
    <a
      v-for="media of socialNetworks"
      :key="media.network"
      class="container__item"
      :href="getUrl(media.link, media.network === 'email')"
      target="_blank"
    >
      <thumbnail :src="imageSrc(media.network)" size="42px" />
      <div class="container__item-network">
        {{ media.network | capitalize }}
      </div>
    </a>
  </div>
</template>
<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail';

export default {
  components: { Thumbnail },
  filters: {
    capitalize: value => {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  props: {
    socialNetworks: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    imageSrc(network) {
      // eslint-disable-next-line
      return require(`dashboard/assets/images/${network}.png`);
    },
    getUrl(link, isEmail = false) {
      return isEmail ? `mailto: ${link}` : link;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  padding: 8px;
  margin-top: 10px;
}
.container__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 64px;
  justify-content: space-between;
  margin: 0;
  flex-shrink: 0;

  .container__item-network {
    font-size: 12px;
    color: #333;
  }
}

@media screen and (max-width: 240px) {
  .container__item {
    height: 54px;

    .container__item-network {
      font-size: 10px;
    }

    .user-thumbnail-box.is-rounded {
      width: 32px !important;
      height: 32px !important;
    }
  }
}
</style>
